import { createRequestTypes } from '../utils';

export const LABEL_REVIEW_LIST = createRequestTypes('labelReview/LABEL_REVIEW_LIST');
export const LABEL_REVIEW_FOR_PRODUCT_LIST = createRequestTypes('labelReview/LABEL_REVIEW_FOR_PRODUCT_LIST');

export const SAVE_LABEL_REVIEW = createRequestTypes('labelReview/SAVE_LABEL_REVIEW');
export const UPDATE_LABEL_REVIEW = createRequestTypes('labelReview/UPDATE_LABEL_REVIEW');
export const FETCH_LABEL_REVIEWS = createRequestTypes('labelReview/FETCH_LABEL_REVIEWS');
